import React from 'react';
import { Controller } from 'react-hook-form';

import { InputAdornment, TextField } from '@material-ui/core';

/**
 * ACTMT standard TextField full width forms.
 * TODO: see https://github.com/kiwicom/orbit-components/issues/902 where
 *       1password changes background color.
 * TODO: Test
 * @param {object} prop React property object.
 * React Component (https://reactjs.org/docs/react-component.html)
 */
function AMTextField(prop: any) {
  // TODO: Verify properties and generate helpful error messages
  const name = prop.name;
  const field = prop.schema.fields[name];

  if (!field) {
    throw new Error(`Schema property '${name}' is missing from schema.`);
  }
  const desc = field.describe();

  return React.createElement(Controller, {
    as: TextField,
    control: prop.control,
    variant: 'outlined',
    margin: 'normal',
    fullWidth: true,
    name: name,
    label: desc.label,
    type: name,
    id: name,
    helperText: prop.errors[name]?.message,
    error: Boolean(prop.errors[name]),
    defaultValue: field.default(),
    InputProps: {
      startAdornment: React.createElement(
        InputAdornment,
        { position: 'start' },
        React.createElement(prop.icon, { color: 'action' }),
      ),
    },
  });
}

export { AMTextField };
